export var ViewMode;
(function (ViewMode) {
    ViewMode["time"] = "time";
    ViewMode["dateTime"] = "dateTime";
    ViewMode["week"] = "week";
    ViewMode["date"] = "date";
    ViewMode["month"] = "month";
    ViewMode["year"] = "year";
    ViewMode["decade"] = "decade";
})(ViewMode || (ViewMode = {}));
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["hour"] = "h";
    TimeUnit["minute"] = "m";
    TimeUnit["second"] = "s";
    TimeUnit["a"] = "a";
})(TimeUnit || (TimeUnit = {}));
